module.exports = __webpack_public_path__ + "img/i_nav_chat_new_off.4e325e30.svg";